<template>
  <div class="card-on-card card-outline-secondary" id="forScrollBook">
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Produk</h5>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Judul Buku</label
        >
        <div class="col-lg-9">
          <input
            class="form-control"
            :value="valName"
            name="bookName"
            id="bookName"
            @change="seoRules()"
            required
            type="text"
            readonly
          />
          <input
            type="hidden"
            class="form-control"
            name="bookTag"
            id="bookTag"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label">SEO</label>
        <div class="col-lg-9">
          <input
            class="form-control"
            id="bookSeo"
            name="bookSeo"
            required
            type="text"
            readonly
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >SK Kelulusan</label
        >
        <div class="col-lg-5">
          <input
            class="form-control"
            name="bookGraduationCertificate"
            id="bookGraduationCertificate"
            required
            type="text"
            readonly
          />
        </div>
        <div class="col-lg-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >Author</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="bookAuthor"
              readonly="true"
              id="bookAuthor"
              :value="valAuthor"
            />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Jenjang</label
        >
        <div :class="typebook == 'text' ? 'col-lg-3' : 'col'">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                v-show="typeBook != 'nontext'"
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >Jenjang</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="bookLevel"
              readonly="true"
              id="jenjang"
              :value="valJenjang"
            />
          </div>
        </div>
        <div v-show="typeBook != 'nontext'" class="col-lg-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >Kelas</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="bookClass"
              readonly="true"
              id="kelas"
              :value="valKelas"
            />
          </div>
        </div>
        <div v-show="typeBook != 'nontext'" class="col-lg-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >Semester</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="bookSemester"
              readonly="true"
              id="semester"
            />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Penerbit</label
        >
        <div class="col-lg-6">
          <!-- <input
            class="form-control"
            type="text"
            name="bookManufacturer"
            readonly="true"
            id="penerbit"
            :value="valPenerbit"
          /> -->
          <select
            class="custom-select"
            name=""
            @change="valPenerbitNew"
            v-model="selectedPenerbit"
            id="bookManufacturer"
            :class="
              selectedPenerbit == ''
                ? 'is-invalid form-control'
                : 'form-control'
            "
          >
            <option value="" selected disabled>Silahkan Pilih Penerbit</option>
            <option
              v-for="(lp, index) in listPenerbit"
              :key="index"
              :value="lp.manufacturer_id"
            >
              {{ lp.name }}
            </option>
          </select>
        </div>

        <div class="col-lg-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >Kondisi</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              readonly="true"
              name="bookCondition"
              id="kondisi"
            />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Kategori</label
        >

        <template v-if="selectedPenerbit != ''">
          <div class="col-lg-3">
            <select
              @change="getCategoryVal"
              name="nonBookCategory"
              id="nonBookCategory"
              class="custom-select custom-select-sm"
            >
              <option
                v-for="(lc, index) in listCategory"
                :key="index"
                :value="lc.id"
              >
                {{ lc.title }}
              </option>
            </select>
          </div>

          <p id="loadingCategory1" class="mt-1 d-none small">
            Loading <i class="fa fa-spinner fa-spin"></i>
          </p>

          <div class="col-lg-3">
            <select
              @change="getSubCategoryVal"
              name="nonBookSubCategory"
              id="nonBookSubCategory"
              class="custom-select custom-select-sm d-none"
            >
              <option
                v-for="(lsc, index) in listSubCategory"
                :key="index"
                :value="lsc.id"
              >
                {{ lsc.title }}
              </option>
            </select>
          </div>

          <p id="loadingCategory2" class="mt-1 d-none small">
            Loading <i class="fa fa-spinner fa-spin"></i>
          </p>

          <div class="col-lg-3">
            <select
              name="nonBookSub2Category"
              id="nonBookSub2Category"
              class="custom-select custom-select-sm d-none"
            >
              <option
                v-for="(lsc, index) in listSub2Category"
                :key="index"
                :value="lsc.id"
              >
                {{ lsc.title }}
              </option>
            </select>
          </div>
        </template>
        <template v-else>
          <div class="col-lg-5">
            <span class="text-danger"
              ><i class="fa fa-info-circle"></i> Pilih Penerbit terlebih dahulu
              yang sesuai dengan table diatas</span
            >
          </div>
        </template>
      </div>

      <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label">Kode</label>

        <div class="col-lg-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >SKU</span
              >
            </div>
            <input
              class="form-control"
              type="text"
              name="bookCode"
              id="bookCode"
            />
          </div>
        </div>

        <div class="col-lg-5">
          <div class="input-group">
            <div class="input-group-prepend">
              <span
                class="p-1 input-group-text"
                style="font-size: 12px; font-weight: 500"
                >ISBN</span
              >
            </div>
            <input class="form-control" type="text" name="bookIsbn" id="isbn" />
          </div>
        </div>
      </div>

      <!-- <div class="form-group row">
        <label class="col-lg-3 col-form-label form-control-label"
          >Kategori</label
        >
        <div class="col-lg-4">
          <select
            name="bookCategory"
            id="bookCategory"
            @change="changeContext(categoryValue)"
            class="form-control"
          >
            <option value="utama">Buku Teks Utama</option>
            <option value="pendamping">Buku Teks Pendamping</option>
          </select>
        </div>

        <div class="col-lg-5">
          <select
            name="bookSubCategory"
            class="form-control"
            id="subCategory"
          ></select>
        </div>
      </div> -->

      <div class="form-group row">
        <label class="col-lg-2 col-form-label form-control-label"
          >Deskripsi</label
        >
        <div class="col-lg-10 offset-md-2">
          <!-- <wysiwyg
                            v-model="sectionProductInformation.description"
                          /> -->
          <quill-editor
            ref="myQuillEditor"
            @change="onEditorChange($event)"
            name="bookDescription"
            :value="valDesc"
          />
        </div>
      </div>

      <div class="form-group row" v-show="typeBook == 'nontext'">
        <label class="col-lg-2 col-form-label form-control-label"
          >Sinopsis</label
        >
        <div class="col-lg-10 offset-md-2">
          <textarea
            disabled
            class="form-control"
            style="
              border: 1px solid #999999;
              border-radius: 2px;
              padding: 1rem 1rem 2rem 1rem;
            "
            id="exampleFormControlTextarea1"
            rows="3"
            v-model="synopsisNonText"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
// import Vue from "vue";
// import VueSelect from "vue-select";
// import axios from "axios";
import $ from "jquery";

export default {
  props: {
    description: String,
    valName: String,
    valPenerbit: String,
    valJenjang: String,
    valKelas: String,
    valAuthor: String,
    valDesc: String,
    synopsisNonText: String,
    onEditorChange: Function,
    valPenerbitNew: Function,
    selectedPenerbit: Number,

    getCategoryVal: Function,
    getSubCategoryVal: Function,
    listPenerbit: Array,
    listCategory: Array,
    listSubCategory: Array,
    listSub2Category: Array,

    typeBook: String,
  },
  data() {
    return {
      categoryValue: "pendamping",
    };
  },
  computed: {
    filteredCategory: function () {
      return this.listCategory.filter(this.filterCatBook);
    },
  },
  components: {
    quillEditor,
    // VueSelect
  },
  mounted() {
    this.seoRules();
    // Vue.component("vue-select", VueSelect);
  },
  created() {
    // setTimeout(() => {
    //   this.changeContext("utama");
    // }, 1000);
  },
  methods: {
    filterCatBook(listCat) {
      return Number(listCat.id > 21 && listCat.id < 24);
    },
    seoRules() {
      setTimeout(() => {
        let string = $("#bookName").val();
        let nilai = string.toLowerCase();

        let dan = nilai.split(/[&]/g).join(" dan ");
        // let str = dan.split(/[^a-z0-9-A-Z]/g).join(", ");
        let str2 = dan.split(/[^a-z0-9-A-Z]/g).join("-");
        let str3 = dan.split(/[^a-z0-9-A-Z]/g).join(", ");

        // $("#bookName").val(str2);
        $("#bookSeo").val(str2);
        $("#bookTag").val(str3);
      }, 660);
    },
  },
};
</script>